module.exports = __webpack_public_path__ + "assets/img/10.49d913ed.gif";